


















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  inheritAttrs: true,
})
export default class Button extends Vue {
  @Prop()
  private readonly color!: string;

  @Prop()
  private readonly size!: string;

  @Prop()
  private readonly type!: string;

  @Prop()
  private readonly loading!: any;

  @Prop({default: false})
  private readonly disabled: boolean;

  @Prop()
  private readonly id!: string;

  @Prop()
  private readonly name!: string;
}
